module.exports = __webpack_public_path__ + "static/Logos-b7f378b456286a96191f222cf92fc688.svg";